import * as React from 'react';
import { useEffect, useState } from 'react';

import { PaywallScreens } from '~analytics/types';
import { translate } from '~l10n/client';
import globalRoom from 'room';
import _ from 'underscore';

import { SmallButton } from '~shared/components/buttons';
import { toast } from '~shared/components/Toast';
import { PaywallDialogGeneric } from '~teacher/components/PaywallDialog';
import { useRoomsPaywallDispatch } from '~teacher/components/rooms/RoomsPaywall/RoomsPaywallProvider';
import { RoomsProTipBar } from '~teacher/components/rooms/RoomsProTipBar';
import { useRoomLimit } from '~teacher/components/rooms/useRoomLimit';
import { proCheck } from '~teacher/util/proCheck';
import Constants from 'Constants';
import RoomItem from 'RoomItem';

let c = null;
let m = null;

class RoomsFilters extends React.Component {
  render() {
    return (
      <div
        className={
          proCheck.canAddRoom() ? 'rooms-filters' : 'rooms-filters disabled'
        }
      >
        <span
          className={
            'filter in-menu-checkbox' +
            (m.roomFilter === 'inMenuASC' || m.roomFilter === 'inMenuDSC'
              ? ' active'
              : '')
          }
          onClick={() => {
            if (proCheck.canAddRoom()) {
              c.filterRooms('in-menu');
            }
          }}
        >
          {translate('In Menu')}
          <i data-icon={m.roomFilter === 'inMenuASC' ? 'k' : 'm'} />
        </span>
        <span
          className={
            'filter room-status-column' +
            (m.roomFilter === 'statusASC' || m.roomFilter === 'statusDSC'
              ? ' active'
              : '')
          }
          onClick={() => {
            if (proCheck.canAddRoom()) {
              c.filterRooms('status');
            }
          }}
        >
          {translate('Status')}
          <i data-icon={m.roomFilter === 'statusASC' ? 'k' : 'm'} />
        </span>
        <span
          className={
            'filter filter-room-name' +
            (m.roomFilter === 'roomNameASC' || m.roomFilter === 'roomNameDSC'
              ? ' active'
              : '')
          }
        >
          {
            <span
              onClick={() => {
                if (proCheck.canAddRoom()) {
                  c.filterRooms('room-name');
                }
              }}
            >
              {translate('Room Name')}
              {<i data-icon={m.roomFilter === 'roomNameASC' ? 'k' : 'm'} />}
            </span>
          }
        </span>
        <span className="right-buttons">
          <span className="right-side">{translate('Share')}</span>
          <span className="right-side">{translate('Roster')}</span>
          <span className="right-side">{translate('Delete')}</span>
        </span>
      </div>
    );
  }
}

export default function RoomsView(props) {
  const [isGenericPaywallOpen, setGenericPaywallOpen] = useState(false);
  const dispatch = useRoomsPaywallDispatch();
  const canAddRoom = proCheck.canAddRoom();

  const roomLimit = useRoomLimit();
  // eslint-disable-next-line react/prop-types
  c = props.controller;
  // eslint-disable-next-line react/prop-types
  m = props.model;
  let roomsList = m.roomsList;

  useEffect(() => {
    try {
      const modalType = JSON.parse(
        localStorage.getItem(Constants.ROSTER_MODAL)
      );
      const roomName = globalRoom.get('name').toLowerCase();
      if (modalType !== null) {
        c.manageRosterClicked(roomName);
      }

      switch (modalType) {
        case 'import':
          c.importClicked(roomName);
          break;
        case 'manual':
          c.manualStudentsClicked();
          break;
        default:
          break;
      }
    } catch (err) {
      console.error('Error parsing roster modal type: ', err);
    } finally {
      localStorage.removeItem(Constants.ROSTER_MODAL);
    }
  }, []);

  const openPaywall = (touch) => {
    dispatch({ type: 'open', payload: { paywallTouch: touch } });
  };

  const toggleGenericPaywall = () => {
    setGenericPaywallOpen(!isGenericPaywallOpen);
  };

  const addRoom = () => {
    if (!canAddRoom) {
      openPaywall([PaywallScreens.RoomsAddRoom]);
      return;
    }

    if (roomsList.length >= Constants.MAX_PRO_ROOMS) {
      toast(translate('You have reached the maximum number of rooms.'), {
        disableClose: true,
      });
      return;
    }

    if (roomsList.length >= roomLimit.data) {
      openPaywall([PaywallScreens.RoomsMaxRooms]);
      return;
    }

    c.addRoomClicked();
    return;
  };

  let roomsListChildren = [];
  const hasRosteredRoom = roomsList.some(
    (room) => room.rostered && room.showbie_class_id === null
  );

  // If no filter is applied, make the default room first in the list.
  if (!m.filtersApplied) {
    let defaultRoom = _.findWhere(roomsList, { default: true });
    roomsList = _.without(roomsList, defaultRoom);
    roomsList.unshift(defaultRoom);
  }

  for (let room of roomsList) {
    let aRoom = (
      <RoomItem key={room.id} room={room} onPaywall={openPaywall} {...props} />
    );

    roomsListChildren.push(aRoom);
  }

  let roomsExtraChildren = '';
  if (roomsList.length < 2) {
    roomsExtraChildren = (
      <div className="w-full h-screen-h-3/5 flex flex-col justify-center items-center">
        <svg
          width="162"
          height="162"
          viewBox="0 0 162 162"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle className="fill-grey-200" cx="54" cy="40.5" r="27" />
          <circle
            className="fill-grey-200"
            cx="114.125"
            cy="50.625"
            r="23.625"
          />
          <path
            className="fill-grey-200"
            d="M63.1875 81H44.8125C26.5871 81 11.8125 95.7746 11.8125 114V129.75C11.8125 136.377 17.1851 141.75 23.8125 141.75H84.1875C90.8149 141.75 96.1875 136.377 96.1875 129.75V114C96.1875 95.7746 81.4129 81 63.1875 81Z"
          />
          <path
            className="fill-grey-200"
            d="M102.188 128.25H136.5C143.127 128.25 148.5 122.877 148.5 116.25V111.75C148.5 98.4952 137.755 87.75 124.5 87.75H105C101.107 87.75 97.4308 88.6768 94.1795 90.3219C99.2029 96.887 102.188 105.095 102.188 114V128.25Z"
          />
        </svg>
        <div className="px-8 py-2 max-w-3xl flex flex-col items-center">
          <span className="py-1 font-display text-md leading-8 font-500 text-blue-900 text-center">
            {translate('Add a Room to Launch More Activities')}
          </span>
          <p className="py-1 font-sans text-base leading-8 text-blue-600 text-center">
            {translate(
              'Run multiple activities at once and group your students with rosters.'
            )}
          </p>
          <div className="pt-6">
            <SmallButton onClick={addRoom}>{translate('Add Room')}</SmallButton>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="rooms-container form">
      <RoomsProTipBar hasRosters={hasRosteredRoom} />
      <div className="flex items-center justify-between">
        <h1 className="text-lg font-700 font-display text-blue-900">
          {translate('Rooms')}{' '}
        </h1>
        <span style={{ position: 'relative' }}>
          <button
            className="button button-primary button-small pill"
            onClick={addRoom}
          >
            <svg
              className="add-room-icon"
              width="16px"
              height="16px"
              viewBox="0 0 16 16"
              dangerouslySetInnerHTML={{
                __html:
                  '<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(-991.000000, -182.000000)" stroke="#FFFFFF" stroke-width="2"><g transform="translate(966.000000, 168.000000)"><g transform="translate(33.000000, 22.000000) rotate(-315.000000) translate(-33.000000, -22.000000) translate(28.000000, 17.000000)"><path d="M8.984375,0.384615385 L4.42312853e-13,9.23076923"></path><path d="M4.42312853e-13,0.769230769 L8.984375,9.61538462"></path></g></g></g></g>',
              }}
            />
            {translate('Add room')}
          </button>
        </span>
      </div>
      <RoomsFilters />
      <ul>{roomsListChildren} </ul>
      {roomsExtraChildren}
      <PaywallDialogGeneric
        open={isGenericPaywallOpen}
        onClose={toggleGenericPaywall}
        paywallScreen={PaywallScreens.RoomsBanner}
      />
    </div>
  );
}
